import React from "react";
import { Link } from "react-router-dom";
import "./ManagementPage.css";

const ManagementPageHero = ({ eyebrow, title, description, actionTo, actionLabel, actionIcon = "fa-plus" }) => (
  <section className="management-hero">
    <div className="management-hero-copy">
      <span className="management-eyebrow"><i className="fa fa-circle" /> {eyebrow}</span>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
    {actionTo && actionLabel && (
      <Link className="management-hero-action" to={actionTo}>
        <i className={`fa ${actionIcon}`} /> {actionLabel}
      </Link>
    )}
  </section>
);

export default ManagementPageHero;
